import type { TripPlannerChat } from 'tripPlanner/api/types'
import { getChatLastActivityTimestamp } from 'tripPlanner/utils/chatTimestamps'

/**
 * Find the chat with the closest activity timestamp to the given chat.
 * Used when deleting the active chat to navigate to a nearby chat.
 */
export function findClosestChat(
  chatHistory: Array<TripPlannerChat>,
  chatIdToCompare: number,
): number | undefined {
  const targetChat = chatHistory.find((chat) => chat.id === chatIdToCompare)
  if (!targetChat) {
    return undefined
  }

  const targetTimestamp = new Date(getChatLastActivityTimestamp(targetChat)).getTime()
  if (Number.isNaN(targetTimestamp)) {
    return undefined
  }

  let closestChatId: number | undefined
  let smallestDifference = Number.POSITIVE_INFINITY

  chatHistory.forEach((chat) => {
    if (chat.id === chatIdToCompare) {
      return
    }
    const timestamp = new Date(getChatLastActivityTimestamp(chat)).getTime()
    if (Number.isNaN(timestamp)) {
      return
    }
    const timeDifference = Math.abs(timestamp - targetTimestamp)
    if (timeDifference < smallestDifference) {
      smallestDifference = timeDifference
      closestChatId = chat.id
    }
  })

  return closestChatId
}
